import React from "react";
import "./styles.scss";
import { useGetUser } from "redux/hooks";
import DateSelector from "../../../components/DateSelector";

const Header = ({ withCustomDates, country, setCountry, state, setState }) => {
  const { user } = useGetUser();

  return (
    <div className="dashboard-header layout-side-padding">
      <h1 className="title">Hey&nbsp;{user.firstname}!</h1>
      <DateSelector withCustomDates={withCustomDates} country={country} setCountry={setCountry} state={state} setState={setState} />
    </div>
  );
};

export default Header;
